
/*
 * Shortens a text label if its length exceeds the `maxWidth`
 */
export default class ChartDrawAbortError extends Error {

}
